import Swiper from "swiper/bundle";

const iconTextSlider = document.querySelector(".icon-text-desc-slider");
if (iconTextSlider) {
  const swiper = new Swiper(iconTextSlider, {
    direction: "horizontal",
    loop: false,
    spaceBetween: 26,
    centeredSlides: false,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 26,
      },
      400: {
        slidesPerView: 1,
        spaceBetween: 26,
      },
      500: {
        slidesPerView: 1.5,
        spaceBetween: 26,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 26,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 26,
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 26,
      },
    },
  });
}
